import React from "react";
import { View } from "react-native";
import Placeholder from "../../general/Placeholder/Placeholder";
import { MotiView } from "moti";
import AnnouncementCard from "../AnnouncementCard/AnnouncementCard";

function AnnouncementCardList({ items = [], onPress }) {
  if (items.length === 0) {
    return <Placeholder subtitle="It looks like there are no announcements yet." />;
  }

  return (
    <View role="list" accessibilityRole="list">
      {items.map(({ id, body, created_date }, index) => (
        <MotiView
          key={id}
          from={{
            opacity: 0,
            translateY: 20,
            scale: 0.95,
          }}
          animate={{
            opacity: 1,
            translateY: 0,
            scale: 1,
          }}
          delay={300 + index * 300}
          transition={{ type: "timing", duration: 800 }}>
          <AnnouncementCard key={id} text={body} createdDate={created_date} onPress={() => onPress(id)} />
        </MotiView>
      ))}
    </View>
  );
}

export default AnnouncementCardList;
